// Helpers de format pour les références de pièces dans les citations,
// listes Doc travail, mini-dossier, exports, etc.
//
// Règle uniforme : on **strip l'extension .pdf/.PDF** du filename_original
// quand on n'a pas de titre_pv plus parlant. Ça évite les "audition.pdf"
// qui polluent visuellement les listes de citations.

import type { PdfMetadata } from './types';

const PDF_EXT_RE = /\.pdf$/i;

/** Retire l'extension `.pdf` (insensible à la casse) si présente. */
export function stripPdfExtension(filename: string): string {
  return filename.replace(PDF_EXT_RE, '');
}

/**
 * Libellé court d'une pièce : `titre_pv` si présent, sinon
 * `filename_original` sans `.pdf`.
 */
export function pieceLabel(p: PdfMetadata | undefined | null): string {
  if (!p) return 'Pièce inconnue';
  if (p.titre_pv && p.titre_pv.trim()) return p.titre_pv;
  return stripPdfExtension(p.filename_original);
}

/**
 * Référence détaillée pour les citations : `[PV n° X · ]<label> · p.<N>`.
 * Si `pageNumber` est null → on omet la partie page.
 */
export function pieceRefLine(p: PdfMetadata | undefined | null, pageNumber: number | null): string {
  if (!p) return pageNumber ? `Page ${pageNumber}` : '—';
  const parts: string[] = [];
  if (p.numero_pv) parts.push(`PV n° ${p.numero_pv}`);
  parts.push(pieceLabel(p));
  if (pageNumber !== null) parts.push(`p. ${pageNumber}`);
  return parts.join(' · ');
}
